import type {
  BetslipActions,
  BetslipStore,
  SliceCreator,
} from "@/features/betslip/stores/types";
import { exitConfirmingIfMutated } from "@/features/betslip/stores/slices/submission";

export const initialTokensState: Pick<BetslipStore, "tokens"> = {
  tokens: { singles: {}, multi: null },
};

export const pruneTokensByOutcomeIds = (
  state: BetslipStore,
  drop: ReadonlySet<string>,
): Pick<BetslipStore, "tokens"> => {
  const nextSingles: Record<string, string> = {};
  for (const [outcomeId, allocId] of Object.entries(state.tokens.singles)) {
    if (!drop.has(outcomeId) && allocId != null)
      nextSingles[outcomeId] = allocId;
  }
  return { tokens: { ...state.tokens, singles: nextSingles } };
};

type TokensActions = Pick<
  BetslipActions,
  "setSingleAllocation" | "setMultiAllocation"
>;

export const tokensSlice: SliceCreator<
  typeof initialTokensState & TokensActions
> = (set) => ({
  ...initialTokensState,

  setSingleAllocation: (outcomeId, allocationId) => {
    set((state) => {
      const current = state.tokens.singles[outcomeId] ?? null;
      if (current === allocationId) return state;

      const nextSingles = { ...state.tokens.singles };
      if (allocationId === null) {
        delete nextSingles[outcomeId];
      } else {
        nextSingles[outcomeId] = allocationId;
      }
      return {
        ...exitConfirmingIfMutated(state),
        tokens: { ...state.tokens, singles: nextSingles },
      };
    });
  },

  setMultiAllocation: (allocationId) => {
    set((state) => {
      if (state.tokens.multi === allocationId) return state;
      return {
        ...exitConfirmingIfMutated(state),
        tokens: { ...state.tokens, multi: allocationId },
      };
    });
  },
});
